/** * 左边菜单 */
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#409EFF">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="" />
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
// import { menu } from "../api/userMG";
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: []
    };
  },
  created() {
    var userInfo = JSON.parse(localStorage.getItem(this.$util.projectNameFn("userdata")));
    // 创建完毕状态(里面是操作) 有权限userInfo.rolesId == 0  
    if (false) {
      // 获取图形验证码
      let res = {
        success: true,
        data: [],
        msg: 'success',
      };
      console.log("111111111",this.$util)
      var permission = JSON.parse(localStorage.getItem(this.$util.projectNameFn("menuIds")));
      // var permission = []
      // 99
      if (permission.indexOf('数据统计模块') != -1) {
        var menus = [];
        if (permission.indexOf('数据统计模块-数据中心')) {
          menus.push({
            menuid: 999,
            icon: "icon-cat-skuQuery",
            menuname: "数据中心",
            hasThird: "N",
            url: "dataStatistics/index",
            menus: null
          });
        }
        res.data.push({
          menuid: 99,
          icon: "li-icon-xiangmuguanli",
          menuname: "数据统计模块",
          hasThird: null,
          url: null,
          menus: menus
        })
      }
      // 1
      if (permission.indexOf('用户模块') != -1) {
        var menus = [];
        if (permission.indexOf('用户模块-用户列表')) {
          menus.push({
            menuid: 11,
            icon: "icon-cat-skuQuery",
            menuname: "用户列表",
            hasThird: "N",
            url: "user/User",
            menus: null
          });
        }
        res.data.push({
          menuid: 1,
          icon: "li-icon-xiangmuguanli",
          menuname: "用户模块",
          hasThird: null,
          url: null,
          menus: menus
        })
      }

      // 16
      if (permission.indexOf('系统模块') != -1) {
        var menus = [];
        if (permission.indexOf('系统模块-包赔设置')) {
          menus.push({
            menuid: 161,
            icon: "icon-cat-skuQuery",
            menuname: "包赔设置",
            hasThird: "N",
            url: "system/guarantee",
            menus: null
          });
        }
        res.data.push({
          menuid: 16,
          icon: "li-icon-xiangmuguanli",
          menuname: "系统模块",
          hasThird: null,
          url: null,
          menus: menus
        })
      }
      this.allmenu = res.data;
      // menu(localStorage.getItem('logintoken'))
      //   .then(res => {
      //     console.log(JSON.stringify(res))
      //     if (res.success) {
      //       this.allmenu = res.data
      //     } else {
      //       this.$message.error(res.msg)
      //       return false
      //     }
      //   })
      //   .catch(err => {
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
      // 监听
      this.$root.Bus.$on("toggle", value => {
        this.collapsed = !value;
      });
    } else {
      // 创建完毕状态(里面是操作) 没有权限
      let res = {
        success: true,
        data: [
          // {
          //   menuid: 99,
          //   icon: "li-icon-xiangmuguanli",
          //   menuname: "数据统计模块",
          //   hasThird: null,
          //   url: null,
          //   menus: [
          //     {
          //       menuid: 999,
          //       icon: "icon-cat-skuQuery",
          //       menuname: "数据中心",
          //       hasThird: "N",
          //       url: "dataStatistics/index",
          //       menus: null
          //     }
          //   ]
          // },
          //1
          {
            menuid: 1,
            icon: "li-icon-xiangmuguanli",
            menuname: "用户模块",
            hasThird: null,
            url: null,
            menus: [
              {
                menuid: 11,
                icon: "icon-cat-skuQuery",
                menuname: "用户列表",
                hasThird: "N",
                url: "user/User",
                menus: null
              }
            ]
          },
          {
            menuid: 2,
            icon: "li-icon-xiangmuguanli",
            menuname: "管理",
            hasThird: null,
            url: null,
            menus: [
              {
                menuid: 21,
                icon: "icon-cat-skuQuery",
                menuname: "轮播图列表",
                hasThird: "N",
                url: "manage/carousel/index",
                menus: null
              }, {
                menuid: 22,
                icon: "icon-cat-skuQuery",
                menuname: "广告套餐设置管理",
                hasThird: "N",
                url: "manage/advertisingPackages/index",
                menus: null
              }, {
                menuid: 23,
                icon: "icon-cat-skuQuery",
                menuname: "公告设置管理",
                hasThird: "N",
                url: "manage/announcement/index",
                menus: null
              }, {
                menuid: 24,
                icon: "icon-cat-skuQuery",
                menuname: "承诺书设置",
                hasThird: "N",
                url: "manage/commitment/index",
                menus: null
              }
              , {
                menuid: 25,
                icon: "icon-cat-skuQuery",
                menuname: "承诺书审核管理",
                hasThird: "N",
                url: "manage/commitment/aduit",
                menus: null
              }
              , {
                menuid: 26,
                icon: "icon-cat-skuQuery",
                menuname: "模板演示分类管理",
                hasThird: "N",
                url: "manage/category/index",
                menus: null
              }, {
                menuid: 27,
                icon: "icon-cat-skuQuery",
                menuname: "自定义设置管理",
                hasThird: "N",
                url: "manage/customize/index",
                menus: null
              }
              // , {
              //   menuid: 28,
              //   icon: "icon-cat-skuQuery",
              //   menuname: "热门队伍设置管理",
              //   hasThird: "N",
              //   url: "manage/hotTeam/index",
              //   menus: null
              // }
              , {
                menuid: 29,
                icon: "icon-cat-skuQuery",
                menuname: "手续费设置",
                hasThird: "N",
                url: "manage/premium/index",
                menus: null
              }
              , {
                menuid: 210,
                icon: "icon-cat-skuQuery",
                menuname: "队伍最大金额限制管理",
                hasThird: "N",
                url: "manage/teamlimit/index",
                menus: null
              }
              , {
                menuid: 211,
                icon: "icon-cat-skuQuery",
                menuname: "提现记录统计管理",
                hasThird: "N",
                url: "manage/teamPayout/index",
                menus: null
              }
              , {
                menuid: 212,
                icon: "icon-cat-skuQuery",
                menuname: "队伍管理",
                hasThird: "N",
                url: "manage/team/index",
                menus: null
              }
              , {
                menuid: 213,
                icon: "icon-cat-skuQuery",
                menuname: "队伍订单管理",
                hasThird: "N",
                url: "manage/teamOrder/index",
                menus: null
              }
              , {
                menuid: 214,
                icon: "icon-cat-skuQuery",
                menuname: "管理员常见问题设置管理",
                hasThird: "N",
                url: "manage/fag/index",
                menus: null
              }
              , {
                menuid: 215,
                icon: "icon-cat-skuQuery",
                menuname: "银行卡手动提现审核管理",
                hasThird: "N",
                url: "manage/teamManualPayout/index",
                menus: null
              }
              , {
                menuid: 216,
                icon: "icon-cat-skuQuery",
                menuname: "版本更新记录管理",
                hasThird: "N",
                url: "manage/versionrecord/index",
                menus: null
              }
            ]
          },

          // 14
          // {
          //   menuid: 14,
          //   icon: "li-icon-xiangmuguanli",
          //   menuname: "角色员工管理",
          //   hasThird: null,
          //   url: null,
          //   menus: [
          //     {
          //       menuid: 141,
          //       icon: "icon-cat-skuQuery",
          //       menuname: "角色员工管理",
          //       hasThird: "N",
          //       url: "system/Admin",
          //       menus: null
          //     }
          //   ]
          // },

          // 16
          // {
          //   menuid: 16,
          //   icon: "li-icon-xiangmuguanli",
          //   menuname: "系统模块",
          //   hasThird: null,
          //   url: null,
          //   menus: [
          //     // {
          //     //   menuid: 1111,
          //     //   icon: "icon-cat-skuQuery",
          //     //   menuname: "角色员工管理",
          //     //   hasThird: "N",
          //     //   url: "system/Admin",
          //     //   menus: null
          //     // },
          //     {
          //       menuid: 161,
          //       icon: "icon-cat-skuQuery",
          //       menuname: "包赔设置",
          //       hasThird: "N",
          //       url: "system/guarantee",
          //       menus: null
          //     },
          //     // {
          //     //   menuid: 1113,
          //     //   icon: "icon-cat-skuQuery",
          //     //   menuname: "协议管理",
          //     //   hasThird: "N",
          //     //   url: "system/Agreement",
          //     //   menus: null
          //     // }
          //   ]
          // },

        ],
        msg: "success"
      };

      this.allmenu = res.data;
      // menu(localStorage.getItem('logintoken'))
      //   .then(res => {
      //     console.log(JSON.stringify(res))
      //     if (res.success) {
      //       this.allmenu = res.data
      //     } else {
      //       this.$message.error(res.msg)
      //       return false
      //     }
      //   })
      //   .catch(err => {
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
      // 监听
      this.$root.Bus.$on("toggle", value => {
        this.collapsed = !value;
      });
    }
  }
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue